import React from "react";
import styled from "@emotion/styled";
import { breakpoints, forSize, heightBreakpoints } from "../utils/sizeMixins";
import FadeIn from "../utils/FadeIn";

const BackgroundContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    margin-bottom: 20px;
`;

const StyledBackground = styled.div(({ showBorder }) => (`
    background-color: var(--navbar-background-color);
    border-radius: 25px;
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 90vh;
    ${showBorder ? `border: 2px solid var(--border-color);` : ''}

    ${forSize(heightBreakpoints.small, 'down', 'y')} {
        height: 95vh;
    }

    overflow: hidden;
    max-width: 1800px;
    transition: background-color 0.2s ease-in-out, border 0.2s ease-in-out;
`));

const Navbar = styled.div`
    background-color: var(--navbar-background-color);
    height: 100%;
    transition: background-color 0.2s ease-in-out;
    backdrop-filter: blur(7px);

    ${forSize(breakpoints.desktopMd, 'up')} {
        width: 16%;
    }

    ${forSize(breakpoints.desktopMd, 'down')} {
        width: 20%;
    }

    ${forSize(breakpoints.tabletLg, 'down')} {
        width: 27%;
    }

`;

const Content = styled.div`
    background-color: var(--content-background-color);
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    transition: background-color 0.2s ease-in-out;
    backdrop-filter: blur(5px);
    max-height: 100%;
   

    ${forSize(breakpoints.desktopMd, 'up')} {
        width: 84%;
    }

    ${forSize(breakpoints.desktopMd, 'down')} {
        width: 80%;
    }

    ${forSize(breakpoints.tabletLg, 'down')} {
        width: 73%;
    }
`;

const Background = ({ navbar, children, showBorder }) => (
    <FadeIn>
        <BackgroundContainer>
            <StyledBackground showBorder={showBorder}>
                <Navbar>{navbar}</Navbar>
                <Content>{children}</Content>
            </StyledBackground>
        </BackgroundContainer>
    </FadeIn>
);

export default Background;